import FlagAD from 'country-flag-icons/react/3x2/AD';
import FlagAE from 'country-flag-icons/react/3x2/AE';
import FlagAL from 'country-flag-icons/react/3x2/AL';
import FlagAM from 'country-flag-icons/react/3x2/AM';
import FlagAR from 'country-flag-icons/react/3x2/AR';
import FlagAT from 'country-flag-icons/react/3x2/AT';
import FlagAU from 'country-flag-icons/react/3x2/AU';
import FlagAZ from 'country-flag-icons/react/3x2/AZ';
import FlagBA from 'country-flag-icons/react/3x2/BA';
import FlagBD from 'country-flag-icons/react/3x2/BD';
import FlagBE from 'country-flag-icons/react/3x2/BE';
import FlagBG from 'country-flag-icons/react/3x2/BG';
import FlagBH from 'country-flag-icons/react/3x2/BH';
import FlagBM from 'country-flag-icons/react/3x2/BM';
import FlagBR from 'country-flag-icons/react/3x2/BR';
import FlagBW from 'country-flag-icons/react/3x2/BW';
import FlagCA from 'country-flag-icons/react/3x2/CA';
import FlagCH from 'country-flag-icons/react/3x2/CH';
import FlagCL from 'country-flag-icons/react/3x2/CL';
import FlagCO from 'country-flag-icons/react/3x2/CO';
import FlagCR from 'country-flag-icons/react/3x2/CR';
import FlagCY from 'country-flag-icons/react/3x2/CY';
import FlagCZ from 'country-flag-icons/react/3x2/CZ';
import FlagDE from 'country-flag-icons/react/3x2/DE';
import FlagDK from 'country-flag-icons/react/3x2/DK';
import FlagDO from 'country-flag-icons/react/3x2/DO';
import FlagEC from 'country-flag-icons/react/3x2/EC';
import FlagEE from 'country-flag-icons/react/3x2/EE';
import FlagES from 'country-flag-icons/react/3x2/ES';
import FlagFI from 'country-flag-icons/react/3x2/FI';
import FlagFO from 'country-flag-icons/react/3x2/FO';
import FlagFR from 'country-flag-icons/react/3x2/FR';
import FlagGB from 'country-flag-icons/react/3x2/GB';
import FlagGE from 'country-flag-icons/react/3x2/GE';
import FlagGG from 'country-flag-icons/react/3x2/GG';
import FlagGI from 'country-flag-icons/react/3x2/GI';
import FlagGL from 'country-flag-icons/react/3x2/GL';
import FlagGR from 'country-flag-icons/react/3x2/GR';
import FlagGT from 'country-flag-icons/react/3x2/GT';
import FlagHK from 'country-flag-icons/react/3x2/HK';
import FlagHN from 'country-flag-icons/react/3x2/HN';
import FlagHR from 'country-flag-icons/react/3x2/HR';
import FlagHU from 'country-flag-icons/react/3x2/HU';
import FlagID from 'country-flag-icons/react/3x2/ID';
import FlagIE from 'country-flag-icons/react/3x2/IE';
import FlagIL from 'country-flag-icons/react/3x2/IL';
import FlagIM from 'country-flag-icons/react/3x2/IM';
import FlagIN from 'country-flag-icons/react/3x2/IN';
import FlagIS from 'country-flag-icons/react/3x2/IS';
import FlagIT from 'country-flag-icons/react/3x2/IT';
import FlagJE from 'country-flag-icons/react/3x2/JE';
import FlagJM from 'country-flag-icons/react/3x2/JM';
import FlagJO from 'country-flag-icons/react/3x2/JO';
import FlagJP from 'country-flag-icons/react/3x2/JP';
import FlagKG from 'country-flag-icons/react/3x2/KG';
import FlagKH from 'country-flag-icons/react/3x2/KH';
import FlagKW from 'country-flag-icons/react/3x2/KW';
import FlagKY from 'country-flag-icons/react/3x2/KY';
import FlagKZ from 'country-flag-icons/react/3x2/KZ';
import FlagLB from 'country-flag-icons/react/3x2/LB';
import FlagLI from 'country-flag-icons/react/3x2/LI';
import FlagLK from 'country-flag-icons/react/3x2/LK';
import FlagLT from 'country-flag-icons/react/3x2/LT';
import FlagLU from 'country-flag-icons/react/3x2/LU';
import FlagLV from 'country-flag-icons/react/3x2/LV';
import FlagMA from 'country-flag-icons/react/3x2/MA';
import FlagMC from 'country-flag-icons/react/3x2/MC';
import FlagMD from 'country-flag-icons/react/3x2/MD';
import FlagME from 'country-flag-icons/react/3x2/ME';
import FlagMK from 'country-flag-icons/react/3x2/MK';
import FlagMO from 'country-flag-icons/react/3x2/MO';
import FlagMT from 'country-flag-icons/react/3x2/MT';
import FlagMX from 'country-flag-icons/react/3x2/MX';
import FlagMY from 'country-flag-icons/react/3x2/MY';
import FlagMZ from 'country-flag-icons/react/3x2/MZ';
import FlagNI from 'country-flag-icons/react/3x2/NI';
import FlagNL from 'country-flag-icons/react/3x2/NL';
import FlagNO from 'country-flag-icons/react/3x2/NO';
import FlagNZ from 'country-flag-icons/react/3x2/NZ';
import FlagOM from 'country-flag-icons/react/3x2/OM';
import FlagPA from 'country-flag-icons/react/3x2/PA';
import FlagPE from 'country-flag-icons/react/3x2/PE';
import FlagPK from 'country-flag-icons/react/3x2/PK';
import FlagPL from 'country-flag-icons/react/3x2/PL';
import FlagPR from 'country-flag-icons/react/3x2/PR';
import FlagPT from 'country-flag-icons/react/3x2/PT';
import FlagPY from 'country-flag-icons/react/3x2/PY';
import FlagQA from 'country-flag-icons/react/3x2/QA';
import FlagRO from 'country-flag-icons/react/3x2/RO';
import FlagRS from 'country-flag-icons/react/3x2/RS';
import FlagSA from 'country-flag-icons/react/3x2/SA';
import FlagSE from 'country-flag-icons/react/3x2/SE';
import FlagSG from 'country-flag-icons/react/3x2/SG';
import FlagSI from 'country-flag-icons/react/3x2/SI';
import FlagSK from 'country-flag-icons/react/3x2/SK';
import FlagSM from 'country-flag-icons/react/3x2/SM';
import FlagSV from 'country-flag-icons/react/3x2/SV';
import FlagTH from 'country-flag-icons/react/3x2/TH';
import FlagTJ from 'country-flag-icons/react/3x2/TJ';
import FlagTM from 'country-flag-icons/react/3x2/TM';
import FlagTT from 'country-flag-icons/react/3x2/TT';
import FlagTW from 'country-flag-icons/react/3x2/TW';
import FlagUA from 'country-flag-icons/react/3x2/UA';
import FlagUM from 'country-flag-icons/react/3x2/UM';
import FlagUS from 'country-flag-icons/react/3x2/US';
import FlagUY from 'country-flag-icons/react/3x2/UY';
import FlagVI from 'country-flag-icons/react/3x2/VI';
import FlagVN from 'country-flag-icons/react/3x2/VN';
import FlagXK from 'country-flag-icons/react/3x2/XK';
import FlagZA from 'country-flag-icons/react/3x2/ZA';

export const COUNTRIES = [
    { name: "Afghanistan", code: "AFG", phoneCode: "+93" },
    { name: "Albania", code: "ALB", phoneCode: "+355" },
    { name: "Algeria", code: "DZA", phoneCode: "+213" },
    { name: "Andorra", code: "AND", phoneCode: "+376" },
    { name: "Angola", code: "AGO", phoneCode: "+244" },
    { name: "Antigua and Barbuda", code: "ATG", phoneCode: "+1-268" },
    { name: "Argentina", code: "ARG", phoneCode: "+54" },
    { name: "Armenia", code: "ARM", phoneCode: "+374" },
    { name: "Australia", code: "AUS", phoneCode: "+61" },
    { name: "Austria", code: "AUT", phoneCode: "+43" },
    { name: "Azerbaijan", code: "AZE", phoneCode: "+994" },
    { name: "Bahamas", code: "BHS", phoneCode: "+1-242" },
    { name: "Bahrain", code: "BHR", phoneCode: "+973" },
    { name: "Bangladesh", code: "BGD", phoneCode: "+880" },
    { name: "Barbados", code: "BRB", phoneCode: "+1-246" },
    { name: "Belarus", code: "BLR", phoneCode: "+375" },
    { name: "Belgium", code: "BEL", phoneCode: "+32" },
    { name: "Belize", code: "BLZ", phoneCode: "+501" },
    { name: "Benin", code: "BEN", phoneCode: "+229" },
    { name: "Bhutan", code: "BTN", phoneCode: "+975" },
    { name: "Bolivia", code: "BOL", phoneCode: "+591" },
    { name: "Bosnia and Herzegovina", code: "BIH", phoneCode: "+387" },
    { name: "Botswana", code: "BWA", phoneCode: "+267" },
    { name: "Brazil", code: "BRA", phoneCode: "+55" },
    { name: "Brunei Darussalam", code: "BRN", phoneCode: "+673" },
    { name: "Bulgaria", code: "BGR", phoneCode: "+359" },
    { name: "Burkina Faso", code: "BFA", phoneCode: "+226" },
    { name: "Burundi", code: "BDI", phoneCode: "+257" },
    { name: "Cabo Verde", code: "CPV", phoneCode: "+238" },
    { name: "Cambodia", code: "KHM", phoneCode: "+855" },
    { name: "Cameroon", code: "CMR", phoneCode: "+237" },
    { name: "Canada", code: "CAN", phoneCode: "+1" },
    { name: "Central African Republic", code: "CAF", phoneCode: "+236" },
    { name: "Chad", code: "TCD", phoneCode: "+235" },
    { name: "Chile", code: "CHL", phoneCode: "+56" },
    { name: "China", code: "CHN", phoneCode: "+86" },
    { name: "Colombia", code: "COL", phoneCode: "+57" },
    { name: "Comoros", code: "COM", phoneCode: "+269" },
    { name: "Congo", code: "COG", phoneCode: "+242" },
    { name: "Congo, Democratic Republic of the", code: "COD", phoneCode: "+243" },
    { name: "Costa Rica", code: "CRI", phoneCode: "+506" },
    { name: "Croatia", code: "HRV", phoneCode: "+385" },
    { name: "Cuba", code: "CUB", phoneCode: "+53" },
    { name: "Cyprus", code: "CYP", phoneCode: "+357" },
    { name: "Czech Republic", code: "CZE", phoneCode: "+420" },
    { name: "Denmark", code: "DNK", phoneCode: "+45" },
    { name: "Djibouti", code: "DJI", phoneCode: "+253" },
    { name: "Dominica", code: "DMA", phoneCode: "+1-767" },
    { name: "Dominican Republic", code: "DOM", phoneCode: "+1-809" },
    { name: "Ecuador", code: "ECU", phoneCode: "+593" },
    { name: "Egypt", code: "EGY", phoneCode: "+20" },
    { name: "El Salvador", code: "SLV", phoneCode: "+503" },
    { name: "Equatorial Guinea", code: "GNQ", phoneCode: "+240" },
    { name: "Eritrea", code: "ERI", phoneCode: "+291" },
    { name: "Estonia", code: "EST", phoneCode: "+372" },
    { name: "Eswatini", code: "SWZ", phoneCode: "+268" },
    { name: "Ethiopia", code: "ETH", phoneCode: "+251" },
    { name: "Fiji", code: "FJI", phoneCode: "+679" },
    { name: "Finland", code: "FIN", phoneCode: "+358" },
    { name: "France", code: "FRA", phoneCode: "+33" },
    { name: "Gabon", code: "GAB", phoneCode: "+241" },
    { name: "Gambia", code: "GMB", phoneCode: "+220" },
    { name: "Georgia", code: "GEO", phoneCode: "+995" },
    { name: "Germany", code: "DEU", phoneCode: "+49" },
    { name: "Ghana", code: "GHA", phoneCode: "+233" },
    { name: "Greece", code: "GRC", phoneCode: "+30" },
    { name: "Grenada", code: "GRD", phoneCode: "+1-473" },
    { name: "Guatemala", code: "GTM", phoneCode: "+502" },
    { name: "Guinea", code: "GIN", phoneCode: "+224" },
    { name: "Guinea-Bissau", code: "GNB", phoneCode: "+245" },
    { name: "Guyana", code: "GUY", phoneCode: "+592" },
    { name: "Haiti", code: "HTI", phoneCode: "+509" },
    { name: "Honduras", code: "HND", phoneCode: "+504" },
    { name: "Hungary", code: "HUN", phoneCode: "+36" },
    { name: "Iceland", code: "ISL", phoneCode: "+354" },
    { name: "India", code: "IND", phoneCode: "+91" },
    { name: "Indonesia", code: "IDN", phoneCode: "+62" },
    { name: "Iran", code: "IRN", phoneCode: "+98" },
    { name: "Iraq", code: "IRQ", phoneCode: "+964" },
    { name: "Ireland", code: "IRL", phoneCode: "+353" },
    { name: "Israel", code: "ISR", phoneCode: "+972" },
    { name: "Italy", code: "ITA", phoneCode: "+39" },
    { name: "Jamaica", code: "JAM", phoneCode: "+1-876" },
    { name: "Japan", code: "JPN", phoneCode: "+81" },
    { name: "Jordan", code: "JOR", phoneCode: "+962" },
    { name: "Kazakhstan", code: "KAZ", phoneCode: "+7" },
    { name: "Kenya", code: "KEN", phoneCode: "+254" },
    { name: "Kiribati", code: "KIR", phoneCode: "+686" },
    { name: "Korea, Democratic People's Republic of", code: "PRK", phoneCode: "+850" },
    { name: "Korea, Republic of", code: "KOR", phoneCode: "+82" },
    { name: "Kuwait", code: "KWT", phoneCode: "+965" },
    { name: "Kyrgyzstan", code: "KGZ", phoneCode: "+996" },
    { name: "Lao People's Democratic Republic", code: "LAO", phoneCode: "+856" },
    { name: "Latvia", code: "LVA", phoneCode: "+371" },
    { name: "Lebanon", code: "LBN", phoneCode: "+961" },
    { name: "Lesotho", code: "LSO", phoneCode: "+266" },
    { name: "Liberia", code: "LBR", phoneCode: "+231" },
    { name: "Libya", code: "LBY", phoneCode: "+218" },
    { name: "Liechtenstein", code: "LIE", phoneCode: "+423" },
    { name: "Lithuania", code: "LTU", phoneCode: "+370" },
    { name: "Luxembourg", code: "LUX", phoneCode: "+352" },
    { name: "Madagascar", code: "MDG", phoneCode: "+261" },
    { name: "Malawi", code: "MWI", phoneCode: "+265" },
    { name: "Malaysia", code: "MYS", phoneCode: "+60" },
    { name: "Maldives", code: "MDV", phoneCode: "+960" },
    { name: "Mali", code: "MLI", phoneCode: "+223" },
    { name: "Malta", code: "MLT", phoneCode: "+356" },
    { name: "Marshall Islands", code: "MHL", phoneCode: "+692" },
    { name: "Mauritania", code: "MRT", phoneCode: "+222" },
    { name: "Mauritius", code: "MUS", phoneCode: "+230" },
    { name: "Mexico", code: "MEX", phoneCode: "+52" },
    { name: "Micronesia (Federated States of)", code: "FSM", phoneCode: "+691" },
    { name: "Moldova", code: "MDA", phoneCode: "+373" },
    { name: "Monaco", code: "MCO", phoneCode: "+377" },
    { name: "Mongolia", code: "MNG", phoneCode: "+976" },
    { name: "Montenegro", code: "MNE", phoneCode: "+382" },
    { name: "Morocco", code: "MAR", phoneCode: "+212" },
    { name: "Mozambique", code: "MOZ", phoneCode: "+258" },
    { name: "Myanmar", code: "MMR", phoneCode: "+95" },
    { name: "Namibia", code: "NAM", phoneCode: "+264" },
    { name: "Nauru", code: "NRU", phoneCode: "+674" },
    { name: "Nepal", code: "NPL", phoneCode: "+977" },
    { name: "Netherlands", code: "NLD", phoneCode: "+31" },
    { name: "New Zealand", code: "NZL", phoneCode: "+64" },
    { name: "Nicaragua", code: "NIC", phoneCode: "+505" },
    { name: "Niger", code: "NER", phoneCode: "+227" },
    { name: "Nigeria", code: "NGA", phoneCode: "+234" },
    { name: "North Macedonia", code: "MKD", phoneCode: "+389" },
    { name: "Norway", code: "NOR", phoneCode: "+47" },
    { name: "Oman", code: "OMN", phoneCode: "+968" },
    { name: "Pakistan", code: "PAK", phoneCode: "+92" },
    { name: "Palau", code: "PLW", phoneCode: "+680" },
    { name: "Panama", code: "PAN", phoneCode: "+507" },
    { name: "Papua New Guinea", code: "PNG", phoneCode: "+675" },
    { name: "Paraguay", code: "PRY", phoneCode: "+595" },
    { name: "Peru", code: "PER", phoneCode: "+51" },
    { name: "Philippines", code: "PHL", phoneCode: "+63" },
    { name: "Poland", code: "POL", phoneCode: "+48" },
    { name: "Portugal", code: "PRT", phoneCode: "+351" },
    { name: "Qatar", code: "QAT", phoneCode: "+974" },
    { name: "Romania", code: "ROU", phoneCode: "+40" },
    { name: "Russian Federation", code: "RUS", phoneCode: "+7" },
    { name: "Rwanda", code: "RWA", phoneCode: "+250" },
    { name: "Saint Kitts and Nevis", code: "KNA", phoneCode: "+1-869" },
    { name: "Saint Lucia", code: "LCA", phoneCode: "+1-758" },
    { name: "Saint Vincent and the Grenadines", code: "VCT", phoneCode: "+1-784" },
    { name: "Samoa", code: "WSM", phoneCode: "+685" },
    { name: "San Marino", code: "SMR", phoneCode: "+378" },
    { name: "Sao Tome and Principe", code: "STP", phoneCode: "+239" },
    { name: "Saudi Arabia", code: "SAU", phoneCode: "+966" },
    { name: "Senegal", code: "SEN", phoneCode: "+221" },
    { name: "Serbia", code: "SRB", phoneCode: "+381" },
    { name: "Seychelles", code: "SYC", phoneCode: "+248" },
    { name: "Sierra Leone", code: "SLE", phoneCode: "+232" },
    { name: "Singapore", code: "SGP", phoneCode: "+65" },
    { name: "Slovakia", code: "SVK", phoneCode: "+421" },
    { name: "Slovenia", code: "SVN", phoneCode: "+386" },
    { name: "Solomon Islands", code: "SLB", phoneCode: "+677" },
    { name: "Somalia", code: "SOM", phoneCode: "+252" },
    { name: "South Africa", code: "ZAF", phoneCode: "+27" },
    { name: "South Sudan", code: "SSD", phoneCode: "+211" },
    { name: "Spain", code: "ESP", phoneCode: "+34" },
    { name: "Sri Lanka", code: "LKA", phoneCode: "+94" },
    { name: "Sudan", code: "SDN", phoneCode: "+249" },
    { name: "Suriname", code: "SUR", phoneCode: "+597" },
    { name: "Sweden", code: "SWE", phoneCode: "+46" },
    { name: "Switzerland", code: "CHE", phoneCode: "+41" },
    { name: "Syrian Arab Republic", code: "SYR", phoneCode: "+963" },
    { name: "Tajikistan", code: "TJK", phoneCode: "+992" },
    { name: "Tanzania, United Republic of", code: "TZA", phoneCode: "+255" },
    { name: "Thailand", code: "THA", phoneCode: "+66" },
    { name: "Timor-Leste", code: "TLS", phoneCode: "+670" },
    { name: "Togo", code: "TGO", phoneCode: "+228" },
    { name: "Tonga", code: "TON", phoneCode: "+676" },
    { name: "Trinidad and Tobago", code: "TTO", phoneCode: "+1-868" },
    { name: "Tunisia", code: "TUN", phoneCode: "+216" },
    { name: "Turkey", code: "TUR", phoneCode: "+90" },
    { name: "Turkmenistan", code: "TKM", phoneCode: "+993" },
    { name: "Tuvalu", code: "TUV", phoneCode: "+688" },
    { name: "Uganda", code: "UGA", phoneCode: "+256" },
    { name: "Ukraine", code: "UKR", phoneCode: "+380" },
    { name: "United Arab Emirates", code: "ARE", phoneCode: "+971" },
    { name: "United Kingdom", code: "GBR", phoneCode: "+44" },
    { name: "United States of America", code: "USA", phoneCode: "+1" },
    { name: "Uruguay", code: "URY", phoneCode: "+598" },
    { name: "Uzbekistan", code: "UZB", phoneCode: "+998" },
    { name: "Vanuatu", code: "VUT", phoneCode: "+678" },
    { name: "Venezuela", code: "VEN", phoneCode: "+58" },
    { name: "Viet Nam", code: "VNM", phoneCode: "+84" },
    { name: "Yemen", code: "YEM", phoneCode: "+967" },
    { name: "Zambia", code: "ZMB", phoneCode: "+260" },
    { name: "Zimbabwe", code: "ZWE", phoneCode: "+263" }
].map( country => { return {
    ...country,
    phoneCodeRegex: new RegExp(`^${country.phoneCode.replace('+','\\+')}($|[^0-9])`)
}} );

/**
 * Countries supported by the Google Service (Google Pay / Google Wallet) flow.
 * GBR is always first; remaining entries are sorted alphabetically by name.
 * `code` is the ISO 3166-1 alpha-3 value sent to the API.
 * `Flag` is the SVG flag component shown in the country dropdown.
 */
export const GOOGLE_SERVICE_COUNTRIES = [
    { code: 'GBR', Flag: FlagGB, name: 'United Kingdom' },
    { code: 'ALB', Flag: FlagAL, name: 'Albania' },
    { code: 'AND', Flag: FlagAD, name: 'Andorra' },
    { code: 'ARG', Flag: FlagAR, name: 'Argentina' },
    { code: 'ARM', Flag: FlagAM, name: 'Armenia' },
    { code: 'AUS', Flag: FlagAU, name: 'Australia' },
    { code: 'AUT', Flag: FlagAT, name: 'Austria' },
    { code: 'AZE', Flag: FlagAZ, name: 'Azerbaijan' },
    { code: 'BHR', Flag: FlagBH, name: 'Bahrain' },
    { code: 'BGD', Flag: FlagBD, name: 'Bangladesh' },
    { code: 'BEL', Flag: FlagBE, name: 'Belgium' },
    { code: 'BMU', Flag: FlagBM, name: 'Bermuda' },
    { code: 'BIH', Flag: FlagBA, name: 'Bosnia & Herzegovina' },
    { code: 'BWA', Flag: FlagBW, name: 'Botswana' },
    { code: 'BRA', Flag: FlagBR, name: 'Brazil' },
    { code: 'BGR', Flag: FlagBG, name: 'Bulgaria' },
    { code: 'KHM', Flag: FlagKH, name: 'Cambodia' },
    { code: 'CAN', Flag: FlagCA, name: 'Canada' },
    { code: 'CYM', Flag: FlagKY, name: 'Cayman Islands' },
    { code: 'CHL', Flag: FlagCL, name: 'Chile' },
    { code: 'COL', Flag: FlagCO, name: 'Colombia' },
    { code: 'CRI', Flag: FlagCR, name: 'Costa Rica' },
    { code: 'HRV', Flag: FlagHR, name: 'Croatia' },
    { code: 'CYP', Flag: FlagCY, name: 'Cyprus' },
    { code: 'CZE', Flag: FlagCZ, name: 'Czechia' },
    { code: 'DNK', Flag: FlagDK, name: 'Denmark' },
    { code: 'DOM', Flag: FlagDO, name: 'Dominican Republic' },
    { code: 'ECU', Flag: FlagEC, name: 'Ecuador' },
    { code: 'SLV', Flag: FlagSV, name: 'El Salvador' },
    { code: 'EST', Flag: FlagEE, name: 'Estonia' },
    { code: 'FRO', Flag: FlagFO, name: 'Faroe Islands' },
    { code: 'FIN', Flag: FlagFI, name: 'Finland' },
    { code: 'FRA', Flag: FlagFR, name: 'France' },
    { code: 'GEO', Flag: FlagGE, name: 'Georgia' },
    { code: 'DEU', Flag: FlagDE, name: 'Germany' },
    { code: 'GIB', Flag: FlagGI, name: 'Gibraltar' },
    { code: 'GRC', Flag: FlagGR, name: 'Greece' },
    { code: 'GRL', Flag: FlagGL, name: 'Greenland' },
    { code: 'GTM', Flag: FlagGT, name: 'Guatemala' },
    { code: 'GGY', Flag: FlagGG, name: 'Guernsey' },
    { code: 'HND', Flag: FlagHN, name: 'Honduras' },
    { code: 'HKG', Flag: FlagHK, name: 'Hong Kong' },
    { code: 'HUN', Flag: FlagHU, name: 'Hungary' },
    { code: 'ISL', Flag: FlagIS, name: 'Iceland' },
    { code: 'IND', Flag: FlagIN, name: 'India' },
    { code: 'IDN', Flag: FlagID, name: 'Indonesia' },
    { code: 'IRL', Flag: FlagIE, name: 'Ireland' },
    { code: 'IMN', Flag: FlagIM, name: 'Isle of Man' },
    { code: 'ISR', Flag: FlagIL, name: 'Israel' },
    { code: 'ITA', Flag: FlagIT, name: 'Italy' },
    { code: 'JAM', Flag: FlagJM, name: 'Jamaica' },
    { code: 'JPN', Flag: FlagJP, name: 'Japan' },
    { code: 'JEY', Flag: FlagJE, name: 'Jersey' },
    { code: 'JOR', Flag: FlagJO, name: 'Jordan' },
    { code: 'KAZ', Flag: FlagKZ, name: 'Kazakhstan' },
    { code: 'XKX', Flag: FlagXK, name: 'Kosovo' },
    { code: 'KWT', Flag: FlagKW, name: 'Kuwait' },
    { code: 'KGZ', Flag: FlagKG, name: 'Kyrgyzstan' },
    { code: 'LVA', Flag: FlagLV, name: 'Latvia' },
    { code: 'LBN', Flag: FlagLB, name: 'Lebanon' },
    { code: 'LIE', Flag: FlagLI, name: 'Liechtenstein' },
    { code: 'LTU', Flag: FlagLT, name: 'Lithuania' },
    { code: 'LUX', Flag: FlagLU, name: 'Luxembourg' },
    { code: 'MAC', Flag: FlagMO, name: 'Macao' },
    { code: 'MYS', Flag: FlagMY, name: 'Malaysia' },
    { code: 'MLT', Flag: FlagMT, name: 'Malta' },
    { code: 'MEX', Flag: FlagMX, name: 'Mexico' },
    { code: 'MDA', Flag: FlagMD, name: 'Moldova' },
    { code: 'MCO', Flag: FlagMC, name: 'Monaco' },
    { code: 'MNE', Flag: FlagME, name: 'Montenegro' },
    { code: 'MAR', Flag: FlagMA, name: 'Morocco' },
    { code: 'MOZ', Flag: FlagMZ, name: 'Mozambique' },
    { code: 'NLD', Flag: FlagNL, name: 'Netherlands' },
    { code: 'NZL', Flag: FlagNZ, name: 'New Zealand' },
    { code: 'NIC', Flag: FlagNI, name: 'Nicaragua' },
    { code: 'MKD', Flag: FlagMK, name: 'North Macedonia' },
    { code: 'NOR', Flag: FlagNO, name: 'Norway' },
    { code: 'OMN', Flag: FlagOM, name: 'Oman' },
    { code: 'PAK', Flag: FlagPK, name: 'Pakistan' },
    { code: 'PAN', Flag: FlagPA, name: 'Panama' },
    { code: 'PRY', Flag: FlagPY, name: 'Paraguay' },
    { code: 'PER', Flag: FlagPE, name: 'Peru' },
    { code: 'POL', Flag: FlagPL, name: 'Poland' },
    { code: 'PRT', Flag: FlagPT, name: 'Portugal' },
    { code: 'PRI', Flag: FlagPR, name: 'Puerto Rico' },
    { code: 'QAT', Flag: FlagQA, name: 'Qatar' },
    { code: 'ROU', Flag: FlagRO, name: 'Romania' },
    { code: 'SMR', Flag: FlagSM, name: 'San Marino' },
    { code: 'SAU', Flag: FlagSA, name: 'Saudi Arabia' },
    { code: 'SRB', Flag: FlagRS, name: 'Serbia' },
    { code: 'SGP', Flag: FlagSG, name: 'Singapore' },
    { code: 'SVK', Flag: FlagSK, name: 'Slovakia' },
    { code: 'SVN', Flag: FlagSI, name: 'Slovenia' },
    { code: 'ZAF', Flag: FlagZA, name: 'South Africa' },
    { code: 'ESP', Flag: FlagES, name: 'Spain' },
    { code: 'LKA', Flag: FlagLK, name: 'Sri Lanka' },
    { code: 'SWE', Flag: FlagSE, name: 'Sweden' },
    { code: 'CHE', Flag: FlagCH, name: 'Switzerland' },
    { code: 'TWN', Flag: FlagTW, name: 'Taiwan' },
    { code: 'TJK', Flag: FlagTJ, name: 'Tajikistan' },
    { code: 'THA', Flag: FlagTH, name: 'Thailand' },
    { code: 'TTO', Flag: FlagTT, name: 'Trinidad & Tobago' },
    { code: 'TKM', Flag: FlagTM, name: 'Turkmenistan' },
    { code: 'UMI', Flag: FlagUM, name: 'U.S. Outlying Islands' },
    { code: 'VIR', Flag: FlagVI, name: 'U.S. Virgin Islands' },
    { code: 'UKR', Flag: FlagUA, name: 'Ukraine' },
    { code: 'ARE', Flag: FlagAE, name: 'United Arab Emirates' },
    { code: 'USA', Flag: FlagUS, name: 'United States' },
    { code: 'URY', Flag: FlagUY, name: 'Uruguay' },
    { code: 'VNM', Flag: FlagVN, name: 'Vietnam' },
];

const ROLES = {
    GIFTEE: "giftee", // the beneficiary or user of the card
    GIFTER: "gifter" // the purchaser or sender of the card
}

export {ROLES};